


























































import Vue from 'vue';

interface FormValues {
  email: string;
}

export default Vue.extend({
  data() {
    return {
      busy: false,
      form: this.$form.createForm(this),
    };
  },

  methods: {
    handleSubmit() {
      this.form.validateFields((errors: Error[], values: FormValues) => {
        if (errors === null) {
          this.$coreApp.auth.reset(values.email, (err, res, loading) => {
            if (!loading && err) {
              this.$message.error(`Unable to reset password: ${err.message}`);
            } else if (!loading && !err) {
              this.$message.success(
                `Reset password email sent to ${values.email}`,
              );
              this.$router.back();
            }
          });
        }
      });
    },
  },
});
